<template>
  <div>
    <div v-html="topHtml"></div>

    <div id="cmCertificate-login">
      <v-text-field ref="codeField" v-model="code" :label="codeLabel"> </v-text-field>
      <div v-if="isUseCredentials">
        <v-text-field v-model="password" type="password" :label="passwordLabel">
        </v-text-field>
      </div>
      <div>
        <v-btn
          :disabled="!isLoginButtonEnabled"
          outlined
          color="primary"
          @click="login_click"
          >{{ loginButtonLabel }}</v-btn
        >
      </div>
    </div>

    <div v-html="bottomHtml"></div>
  </div>
</template>

<script>
import services from "@/services/services.js";
import store from "@/store/index.js";

export default {
  name: "Login",
  data: function() {
    return {
      //code: "77701872",
      code: "",
      password: "",
      loginMethod: "",
      completedSurveyCode: ""
    };
  },
  computed: {
    isUseCredentials() {
      return this.loginMethod === "credentials";
    },
    isLoginButtonEnabled() {
      var isEnabled = true;
      if (this.code === "") isEnabled = false;
      if (this.isUseCredentials && this.password === "") isEnabled = false;
      return isEnabled;
    },
    topHtml() {
      return store.state.viewConfiguration.login.topHtml;
    },
    bottomHtml() {
      return store.state.viewConfiguration.login.bottomHtml;
    },
    codeLabel() {
      return store.state.viewConfiguration.login.codeLabel;
    },
    passwordLabel() {
      return store.state.viewConfiguration.login.passwordLabel;
    },
    loginButtonLabel() {
      return store.state.viewConfiguration.login.loginButtonLabel;
    }
  },
  methods: {
    login_click() {
      var afterlogin = resp => {
        if (resp.data.hasError) {
          this.$emit("openErrorDialog", resp.data.errorMessage);
        } else {
          if (resp.data.notification) {
            this.$emit("showSnackbar", resp.data.notification);
          }
          store.setBarcodeAction(resp.data.barcode);
          store.setBarcodeHashAction(resp.data.barcodeHash);
          document.cookie = `cmCertificateBarcode=${resp.data.barcode}`;
          document.cookie = `cmCertificateBarcodeHash=${resp.data.barcodeHash}`;
          this.$router.push({
            name: "CertificateOverview",
            params: { certificates: resp.data.certificates }
          });
        }
      };

      if (this.completedSurveyCode) {
        services
          .LoginAfterSurveyCompletedNoParams(
            this.code,
            this.password,
            this.completedSurveyCode
          )
          .then(resp => afterlogin(resp));
      } else {
        services.login(this.code, this.password).then(resp => afterlogin(resp));
      }
    }
  },
  mounted() {
    this.loginMethod = this.$route.params.loginMethod;
    this.completedSurveyCode = this.$route.params.completedSurveyCode;
    this.$refs.codeField.focus();
  }
};
</script>

<style lang="scss" scoped>
#cmCertificate-login {
  width: 240px;
  margin: 0 auto;
}
</style>
